import APIService from './APIService'

const api = APIService()

export const getMyWorkSummary = () => api.get('/me/work-summary')

export const getMyPerformance = () => api.get('/me/performance')
